import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, SEARCH_GROUPS } from '@constants/Text'

const meta = {
  permission: ['profissional'],
  only_aawz: true,
  external_flag: FEATURES.REQUISICOES,
}

export default [
  {
    path: '/requisicoes',
    name: 'requisicoes',
    redirect: '/requisicoes/overview',
    meta: {
      ...meta,
      search: {
        title: 'Requisições',
        description: 'Requisições internas da operação AAWZ',
        keywords: ['requisições', 'pedidos internos', 'operação', 'chamados'],
        icon: 'mdi-clipboard-list-outline',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@modules/requisicoes/views/nav-bar/requisicoes-nav-bar.vue')
      ),
    children: [
      {
        path: 'overview',
        name: 'requisicoes.overview',
        meta,
        component: () =>
          lazyLoadView(
            import('@modules/requisicoes/views/view-requisicoes.vue')
          ),
      },
    ],
  },
]
